var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._g({staticClass:"hm-table-button"},_vm.$listeners),[_c('i',{class:("icon far fa-" + _vm.icon)})])}
var staticRenderFns = []

export { render, staticRenderFns }